import React, { FC } from 'react';
import { PatientProfile, SideMenu } from 'features';
import { Wrapper } from './styles';
import DeleteAppointmentModal from 'features/feature-delete-appointment';

const PatientPage: FC = () => {
  return (
    <Wrapper>
      <SideMenu />
      <PatientProfile />
      <DeleteAppointmentModal />
    </Wrapper>
  );
};

export default PatientPage;
